export default __webpack_public_path__ + "static/media/cart-banner-lq.c69a3847.jpg";